export class SelectableOption {
  public label: string;
  public value?: string;
  public disabled?: boolean;
  public exclusive?: boolean;
  public description?: string;

  public constructor(label: string, value?: string, disabled?: boolean, exclusive?: boolean, description?: string) {
    this.label = label;
    this.value = value ?? label;
    this.disabled = disabled ?? false;
    this.exclusive = exclusive ?? false;
    this.description = description ?? '';
  }
}
